module.exports = __webpack_public_path__ + "media/images/logo-607178dcc38da2ecdb8d250fb661b259.svg";